export default __webpack_public_path__ + "static/media/expand-collapse-grey-16px.60597f73.svg";